import {
  Route,
  BrowserRouter,
  Routes,
  useLocation,
  Nvigation,
} from "react-router-dom";
import "./App.css";
import LandingPage from "./features/Landing/Landing";
import LandingDoctor from "./features/Landing/LandingDoctor";
import LandingNurse from "./features/Landing/LandingNurse";
import Dashboard from "./features/Patient/Dashboard";
import DashboardWhite from "./features/Patient/DashboardWhite";
import AppointmentBooking from "./features/Patient/AppointmentBooking";
import DoctorDashboard from "./features/Doctor/DoctorDashboard";
import NurseDashboard from "./features/Nurse/NurseDashboard";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/patient" element={<LandingPage />} />
        <Route path="/doctor" element={<LandingDoctor />} />
        <Route path="/nurse" element={<LandingNurse />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboardwhite" element={<DashboardWhite />} />
        <Route path="/bookappointment" element={<AppointmentBooking />} />
        <Route path="/doctordashboard" element={<DoctorDashboard />} />
        <Route path="/nursedashboard" element={<NurseDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
